import { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { BrowserRouter, Route, Routes } from 'react-router';
import Home from "@/pages/Home"
import '@/index.css';


// Lazy load delle pagine
//const Home = lazy(() => import('@/pages/Home'));
const Services = lazy(() => import('@/pages/Services'));
const Contact = lazy(() => import('@/pages/Contact'));
const About = lazy(() => import('@/pages/About'));
const Blog = lazy(() => import('@/pages/Blog'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const PolicyCookie = lazy(() => import('@/components/Privacy/PolicyCookie'));
const PrivacyPolicy = lazy(() => import('@/components/Privacy/PrivacyPolicy'));
const Terms = lazy(() => import('@/components/Privacy/Terms'));




createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
    
    <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<App/>}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />

            <Route path="services" element={<Services />} />
            <Route path="about" element={<About />} />
            <Route path="blog" element={<Blog />} />
            <Route path="contact" element={<Contact />} />
            <Route path="cookiepolicy" element={<PolicyCookie />} />
            <Route path="privacypolicy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<Terms />} />
            {/* Redirect o fallback */}
            <Route path="*" element={<NotFound />} />
          </Route>
            
          
        </Routes>
      </Suspense>
      </BrowserRouter>,
)
